import { LineProps } from '@/components/Controls/Canvas';
import { Group, Shape } from 'react-konva';
import innerFrame from '@/assets/images/frame/inner-selected.svg';
import inner from '@/assets/images/frame/inner.svg';
import outer from '@/assets/images/frame/outer.svg';
import outerSelected from '@/assets/images/frame/outer-selected.svg';
import {
  DEFAULT_CORNER_RADIUS,
  DEFAULT_DRAWING_SCALE,
  DEFAULT_TOP_MARGIN_SIZE
} from '@/components/Host/PlayersCards';

const cardFrameInner = new Image();
cardFrameInner.src = inner;

const cardFrameInnerSelected = new Image();
cardFrameInnerSelected.src = innerFrame;

const cardFrameOuter = new Image();
cardFrameOuter.src = outer;

const cardFrameOuterSelected = new Image();
cardFrameOuterSelected.src = outerSelected;

const scalePoint = (point: number, originalSize: number, newSize: number) => {
  return (point / originalSize) * newSize;
};

export function SubmittedDrawPlayerImage({
  drawing,
  cardSize
}: {
  drawing: any;
  cardSize: { width: number; height: number };
}) {
  const width = DEFAULT_DRAWING_SCALE * cardSize.width; // Width of the rectangle with margin
  const height = DEFAULT_DRAWING_SCALE * cardSize.height; // Height of the rectangle with margin
  const marginLeft = (cardSize.width - width) / 2;
  const marginTop = DEFAULT_TOP_MARGIN_SIZE * cardSize.height;

  return (
    <Group
      x={0}
      y={0}
      width={cardSize.width}
      height={cardSize.height}
      offsetX={-marginLeft}
      offsetY={-marginTop}
    >
      <Group
        clipFunc={(ctx) => {
          const radius = DEFAULT_CORNER_RADIUS * width;
          const x = 0; // Starting x position with margin
          const y = 0; // Starting y position with margin

          ctx.beginPath();
          ctx.moveTo(x + radius, y);
          ctx.lineTo(x + width - radius, y);
          ctx.arcTo(x + width, y, x + width, y + radius, radius);
          ctx.lineTo(x + width, y + height - radius);
          ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
          ctx.lineTo(x + radius, y + height);
          ctx.arcTo(x, y + height, x, y + height - radius, radius);
          ctx.lineTo(x, y + radius);
          ctx.arcTo(x, y, x + radius, y, radius);
          ctx.closePath();
          ctx.clip();
        }}
      >
        {drawing.map((line: LineProps, i: number) => {
          return (
            <Shape
              key={i}
              sceneFunc={(context, shape) => {
                context.beginPath();
                const scaledPoints = line.points.map((point, index) =>
                  index % 2 === 0
                    ? scalePoint(point, line.canvasWidth, width)
                    : scalePoint(point, line.canvasHeight, height)
                );

                context.moveTo(scaledPoints[0], scaledPoints[1]);

                for (let j = 2; j < scaledPoints.length; j += 2) {
                  context.quadraticCurveTo(
                    scaledPoints[j - 2],
                    scaledPoints[j - 1],
                    (scaledPoints[j - 2] + scaledPoints[j]) / 2,
                    (scaledPoints[j - 1] + scaledPoints[j + 1]) / 2
                  );
                }

                context.quadraticCurveTo(
                  scaledPoints[scaledPoints.length - 2],
                  scaledPoints[scaledPoints.length - 1],
                  scaledPoints[scaledPoints.length - 2] + 0.5,
                  scaledPoints[scaledPoints.length - 1]
                );

                context.fillStrokeShape(shape);
              }}
              stroke={line.stroke}
              strokeWidth={(line.width / line.canvasWidth) * width}
              tension={0}
              lineCap="round"
              lineJoin="round"
            />
          );
        })}
      </Group>
    </Group>
  );
}
